import { render, staticRenderFns } from "./WelCome.vue?vue&type=template&id=59c9e900&scoped=true&"
import script from "./WelCome.vue?vue&type=script&lang=ts&"
export * from "./WelCome.vue?vue&type=script&lang=ts&"
import style0 from "./WelCome.vue?vue&type=style&index=0&id=59c9e900&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9e900",
  null
  
)

export default component.exports